import {Link, useLocation} from "react-router-dom"

interface MenuItemProps {
    linkTo: string,
    icon: string,
    name: string,
}

export const MenuItem = ({linkTo, icon, name}: MenuItemProps) => {
    const location = useLocation()
    const parent = linkTo.split("/")[0] || ""
    const isActive = location.pathname.indexOf("/" + parent) === 0
    return (
        <div className={`menu-item ${isActive ? "active" : ""}`}>
            <Link to={linkTo}>
                <span className="icon-text">
                    <span className="icon icon-box">
                        <i className={`fas ${icon}`}/>
                    </span>
                    <span className="icon-text">{name}</span>
                </span>
            </Link>
        </div>
    )
}